<template>
    <div class="carousel-container">
        <el-carousel indicator-position="outside">
        <el-carousel-item v-for="item in imgList" :key="item.id">
            <img :src="item.idView" alt="" class="img">
        </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
data() {
    return {
    imgList: [
        { id: 0, idView: '@/../static/image/workflow.png' },//这里的@ 符号表示 src 目录
        { id: 1, idView: '@/../static/image/Enlist.png' },
        { id: 2, idView: '@/../static/image/feature.png' },
        { id: 3, idView: '@/../static/image/se_e.png' },
        { id: 4, idView: '@/../static/image/tf.png' },
        { id: 5, idView: '@/../static/image/gene.png' },
        { id: 6, idView: '@/../static/image/tf_en_gene.png' },
        { id: 7, idView: '@/../static/image/compartment.png' },
        { id: 8, idView: '@/../static/image/tad.png' },
    ],
    };
},
};
</script>

<style scoped>
.carousel-container {
  height: 310px; /* 调整这里的高度值 */
}
.img {
    max-width: 100%; /* 设置最大宽度为容器的宽度 */
    max-height: 100%; /* 设置最大高度为容器的高度 */
    width: auto; /* 保持宽高比 */
    height: auto; /* 保持宽高比 */
    display: block; /* 去除图片底部间隙 */
    margin: 0 auto; /* 水平居中 */
}
</style>



// WEBPACK FOOTER //
// src/components/home/Carousel.vue